import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import * as Sentry from '@sentry/react';
import { config } from 'dotenv';
import i18n from 'i18n-react';

import CookieWarning from 'components/CookieWarning';

import APIHandler from 'config/APIHandler';
import AppSettings from 'config/AppSettings';
import DataHandler from 'config/DataHandler';
import locales from 'config/i18n';
import { language, storageKeys } from 'config/settings';
import StorageHandler from 'config/StorageHandler';

import { SettingsProvider } from 'hooks/useSettings';
import { UserInfoProvider } from 'hooks/useUserInfo';

import AppRouter from 'routers/AppRouter';

import 'config/FontAwesome';
import 'normalize.css/normalize.css';

import './assets/styles/styles';

const { cookieEnabled } = window.navigator;

config();

if (process.env.NODE_ENV === 'production') {
  Sentry.init({
    dsn: process.env.SENTRY_DSN,
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
  });
}

i18n.setTexts(locales.en); //  setTexts i18n based on localstorage lang fix both on page load

const availableLanguages = language
  .map(({ code }) => (typeof code === 'string' ? code : code.map((c) => c.toLowerCase())))
  .flat();
const commitRisk = language.some((lang) => lang.id === 220 && lang.countries.length > 0);
if (commitRisk) console.error('One of the testing languages is currently in use. Please remove before committing.');

DataHandler.matchAppId().then((appId) => {
  StorageHandler.load(storageKeys.appId).then((id) => {
    if (id !== appId) {
      StorageHandler.removeKeys(
        Object.keys(storageKeys).filter((key) => {
          const k = storageKeys[key];
          return k !== storageKeys.appId && k !== storageKeys.lang;
        }),
      );
      StorageHandler.save(storageKeys.appId, appId);
    } else {
      StorageHandler.save(storageKeys.appId, id);
    }
    StorageHandler.load(storageKeys.lang).then((lang) => {
      i18n.setTexts(locales[lang.langFile]);
    });
    if (sessionStorage.getItem(sessionStorage.key('tt_sessionId')) !== '-1') {
      StorageHandler.load(storageKeys.user).then((res) => {
        if (res) {
          const { email } = res;
          APIHandler.lastActive(appId, email);
          sessionStorage.setItem(sessionStorage.key('tt_sessionId'), -1);
        }
      });
    }
  });
  window.appId = appId;
});

if (cookieEnabled) {
  // Check if language is already set, proceed said language.
  StorageHandler.exists(storageKeys.lang).then((languageExists) => {
    if (languageExists) {
      StorageHandler.load(storageKeys.lang).then((res) => {
        i18n.setTexts(locales[res.langFile]);
      });
    } else {
      // Get user location and check if a language file exists.
      StorageHandler.save(storageKeys.lang, { country: 'United_States', code: 'US', langFile: 'en' });
      i18n.setTexts(locales.en);
      APIHandler.getLocation().then((location) => {
        if (location) {
          const code = location.countryCode.toLowerCase();
          const availableLanguageForUserLocation = (translationFiles) =>
            translationFiles.map((translation) => translation === code).includes(true);
          const [file] = language.filter(({ code: c }) => c.includes(code)).map(({ langFile }) => langFile);

          if (availableLanguageForUserLocation(availableLanguages)) {
            StorageHandler.save(storageKeys.lang, {
              country: location.country.replace(' ', '_'),
              code: code.toLowerCase(),
              langFile: file,
            });
            window.location.reload();
          } else {
            StorageHandler.save(storageKeys.lang, {
              country: location.country.replace(' ', '_'),
              code: location.countryCode.replace(' ', '_'),
              langFile: 'en',
            });
            window.location.reload();
          }
        } else {
          StorageHandler.save(storageKeys.lang, { country: 'United_States', code: 'US', langFile: 'en' });
          i18n.setTexts(locales.en);
          window.location.reload();
        }
      });
    }
  });
  StorageHandler.load('askedMobile').then((askedBefore) => {
    ReactDOM.render(<App askedBefore={askedBefore} />, document.getElementById('root'));
  });
}

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
    };
  }

  componentDidMount() {
    this.setLoader();
  }

  setLoader() {
    AppSettings().then((res) => {
      if (res) {
        this.setState({ loading: false });
      }
    });
  }

  render() {
    const { loading } = this.state;

    return (
      <SettingsProvider>
        <UserInfoProvider>
          <div className="container__router">
            {!cookieEnabled && <CookieWarning />}
            {loading && (
              <div className="appLoader">
                <FontAwesomeIcon icon={['fas', 'circle-notch']} spin />
              </div>
            )}
            {!loading && <AppRouter />}
          </div>
        </UserInfoProvider>
      </SettingsProvider>
    );
  }
}
